<div class="d-flex flex-column h-100">
  <app-navbar />
  <router-outlet />
</div>
